import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SVG_ICONS } from "../../models/icons";
import { MasterService } from "../../serivces/master.service";
import { Router } from "@angular/router";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { PlanDetailsComponent } from "../plan-membership/plan/plan-details/plan-details.component";
import { AddPlanComponent } from "../plan-membership/plan/add-plan/add-plan.component";
import { AddMenuComponent } from "../masters/add-menu/add-menu.component";
import { AddRegionComponent } from "../masters/add-region/add-region.component";
import { AddCityComponent } from "../masters/add-city/add-city.component";
import { AddAreaComponent } from "../masters/add-area/add-area.component";
import { SharedModule } from "@frontend/app/shared/shared.module";
import { UsertypeMasterEntryComponent } from "../user-access/usertype-master-entry/usertype-master-entry.component";
import { AddCompanyComponent } from "../masters/add-company/add-company.component";

@Component({
  selector: "app-settings",
  standalone: true,
  imports: [CommonModule, MatDialogModule, SharedModule],
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
})
export class SettingsComponent implements OnInit {
  private masterService = inject(MasterService);
  private router = inject(Router);
  private dialog = inject(MatDialog);

  // displayedColumns: string[] = ["PackageName", "FinalAmount", "StartTime", "EndTime", "Term", "Status", "Action"];
  // dataSource = new MatTableDataSource<any>([]);
  ngOnInit() {
    // this.getPackageList();
    if (this.selectedTab === "package") {
      this.loadGlobalPackages();

      this.loadLocalPackages();
    }
  }

  //#region variables
  readonly SVG_ICONS = SVG_ICONS;
  packageList: any;
  selectedTab = "package";
  selectedSubTab = "Global Package";

  tabList = [
    // { key: "user-access", label: "User Access", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    { key: "company", label: "Company", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    { key: "package", label: "Package", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    { key: "region", label: "Region", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    // { key: "city", label: "City", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    { key: "area", label: "Area", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    { key: "center", label: "Center", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    { key: "menu", label: "Menu", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
    // { key: "User-Access", label: "User-Access", icon: SVG_ICONS.MEMBERSHIP_PLANS_ICON },
  ];
  cardData: any;
  globalPackageList: any;
  localPackageList: any;
  originalData: any;
  searchTerm = "";
  //#endregion

  getSelectedTabLabel(): string {
    return this.tabList.find(tab => tab.key === this.selectedTab)?.label || "";
  }

  onEditPlan(id: number) {
    this.dialog.open(AddPlanComponent, {
      width: "60%",
      data: { packageId: id },
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.loadLocalPackages();
      this.loadGlobalPackages();
    });
  }

  onCreatePlan() {
    this.dialog.open(AddPlanComponent, {
      width: "60%",
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.loadLocalPackages();
      this.loadGlobalPackages();
    });
  }

  onCreateRegion() {
    this.dialog.open(AddRegionComponent, {
      width: "60%",
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getRegionList();
    });
  }

  onEditRegion(id: number) {
    this.dialog.open(AddRegionComponent, {
      width: "60%",
      data: { regionId: id },
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getRegionList();
    });
  }

  onCreateCity() {
    this.dialog.open(AddCityComponent, {
      width: "60%",
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getCityList();
    });
  }

  onCreateArea() {
    this.dialog.open(AddAreaComponent, {
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
      width: "60%",
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getAreaList();
    });
  }

  onEditArea(id: number) {
    this.dialog.open(AddAreaComponent, {
      width: "60%",
      data: { areaId: id },
      panelClass: "custom-dialog-container",
      backdropClass: "custom-dialog-backdrop",
      hasBackdrop: true,
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getAreaList();
    });
  }

  onPlanDetails(id: number) {
    this.dialog.open(PlanDetailsComponent, {
      width: "60%",
      data: { packageId: id },
    });
  }

  onCreateMenu() {
    const dialogRef = this.dialog.open(AddMenuComponent, {
      width: "60%",
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getMenuList();
    });
  }

  // onCreateMenu(parentMenuId?: number) {
  //   const dialogRef = this.dialog.open(AddMenuComponent, {
  //     width: "60%",
  //     data: parentMenuId ? { ParentMenuID: parentMenuId } : {},
  //   });

  //   dialogRef.afterClosed().subscribe(() => {
  //     this.getMenuList();
  //   });
  // }
  onAction(id: number) {
    this.dialog.open(AddMenuComponent, {
      width: "60%",
      data: { menuId: id },
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getMenuList();
    });
  }

  onUserTypePermissionCreate() {
    this.dialog.open(UsertypeMasterEntryComponent, {
      width: "90%",
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getUserTypeList();
    });
  }

  onUserTypePermissionEdit(id: number) {
    this.dialog.open(UsertypeMasterEntryComponent, {
      width: "90%",
      data: {
        UserTypeID: id,
        UserType: id ? this.cardData.find((item: any) => item.UserTypeID === id)?.UserType : "",
        IsEdit: id ? true : false,
      },
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getUserTypeList();
    });
  }

  onAddCompany() {
    this.dialog.open(AddCompanyComponent, {
      width: "60%",
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getCompanyList();
    });
  }

  onEditCompany(id: number) {
    this.dialog.open(AddCompanyComponent, {
      width: "60%",
      data: { companyId: id },
    });
    this.dialog.afterAllClosed.subscribe(() => {
      this.getCompanyList();
    });
  }

  changeTab(tabKey: string) {
    this.selectedTab = tabKey;
    this.searchTerm = "";
    switch (tabKey) {
      // case "user-access":
      //   this.getUserTypeList();
      //   break;
      case "company":
        this.getCompanyList();
        break;
      case "package":
        this.getPackageList();
        break;
      case "region":
        this.getRegionList();
        break;
      // case "city":
      //   this.getCityList();
      //   break;
      case "area":
        this.getAreaList();
        break;
      case "menu":
        this.getMenuList();
        break;
      case "center":
        this.getCenterList();
        break;
      // case "User-Access":
      //   // this.getUserTypeList();
      //   break;
    }
  }

  onTabChange(tab: "Global Package" | "Local Package(Area Wise)") {
    if (this.selectedSubTab === tab) return;
    this.selectedSubTab = tab;


    if (tab === "Local Package(Area Wise)") {
      this.loadLocalPackages();
    } else if (tab === "Global Package") {
      this.loadGlobalPackages();
    }
  }

  loadLocalPackages() {
    const idsFromSession = sessionStorage.getItem("AllAreaIDs");

    let idArray: number[] = [];
    try {
      idArray = idsFromSession ? JSON.parse(idsFromSession) : [];
    } catch {
      console.error("Invalid IDList format in session storage");
    }

    const idParam = idArray.join(",");

    this.masterService.getPackageListByActionID(idParam, "Area").subscribe({
      next: res => {
        const activePackages = res.data?.filter((pkg: any) => pkg.IsActive === true) || [];
        // this.localPackageList = this.getUniquePackages(activePackages);
        this.localPackageList = activePackages;
        this.originalData = [...this.localPackageList];
      },
      error: err => {
        console.error("Error loading local packages:", err);
        // this.toastrService.error("Failed to load local packages.");
      },
    });
  }

  private getUniquePackages(packages: any[]): any[] {
    const uniquePackages = new Map<string, any>();

    packages.forEach(pkg => {
      const key = `${pkg.PackageName}_${pkg.Amount}`;
      if (!uniquePackages.has(key)) {
        uniquePackages.set(key, pkg);
      }
    });

    return Array.from(uniquePackages.values());
  }

  loadGlobalPackages() {
    this.masterService.getPackageList().subscribe({
      next: res => {
        this.globalPackageList = res.Table?.filter((item: any) => item.ID === 0 && item.IsActive === true) || [];
        this.originalData = [...this.globalPackageList];
      },
      error: err => {
        console.error("Error loading global packages:", err);
        // this.toastrService.error("Failed to load global packages.");
      },
    });
  }

  onEditCenter(CenterID: number) {
    this.router.navigate(["/create-center"], { queryParams: { CenterID: CenterID } });
  }

  getUserTypeList() {
    this.masterService.getUserTypeList().subscribe((res: any) => {
      this.cardData = [];
      this.cardData = res.Table || [];
    });
  }

  // getUserTypeList() {
  //   interval(2000)    // Emit every 1 second
  //     .pipe(take(3)) // Limit to 3 emissions
  //     .subscribe(() => {
  //       this.masterService.getUserTypeList().subscribe((res: any) => {
  //         this.cardData = res.Table || [];
  //       });
  //     });
  // }

  getCompanyList() {
    this.masterService.getCompanyList().subscribe((res: any) => {
      this.cardData = res.data || [];
      this.originalData = [...this.cardData];
    });
  }

  getPackageList() {
    this.masterService.getPackageList().subscribe((res: any) => {
      this.cardData = (res.Table || []).sort((a: any, b: any) => {
        return (b.IsActive === true ? 1 : 0) - (a.IsActive === true ? 1 : 0);
      });
      this.originalData = [...this.cardData];
      // this.dataSource.data = this.cardData;
    });
  }

  getRegionList() {
    this.masterService.getRegionList().subscribe((res: any) => {
      this.cardData = res.Table || [];
      this.originalData = [...this.cardData];
    });
  }

  getCityList() {
    this.masterService.getCityList().subscribe((res: any) => {
      this.cardData = res.data || [];
      this.originalData = [...this.cardData];
    });
  }

  getAreaList() {
    this.masterService.getAreaList().subscribe((res: any) => {

      this.cardData = res.Table || [];
      this.originalData = [...this.cardData];
    });
  }

  getCenterList() {
    this.masterService.getCenterList().subscribe((res: any) => {
      this.cardData = res.data || [];
      this.originalData = [...this.cardData];
    });
  }

  getMenuList() {
    this.masterService.getMenuList(1, 100, "asc").subscribe((res: any) => {
      this.cardData = res.Table;
      this.originalData = [...this.cardData];
    });
  }

  trackByIndex(index: number, _: any): number {
    return index;
  }

  applyFilter(event?: Event) {
    const filterValue = this.searchTerm.trim().toLowerCase();

    if (!filterValue) {
      this.cardData = [...this.originalData];
      return;
    }

    const tabKey = this.selectedTab;
    const filterKeysMap: Record<string, string[]> = {
      company: ["CompanyName", "Address", "City", "State", "Country", "ContactNumber", "PAN", "GSTIN"],
      region: ["RegionName"],
      area: ["AreaName", "RegionName"],
      center: ["CenterName", "Address", "ContactNumber"],
      menu: ["MenuName", "ParentMenuID", "RouterPath"],
      package: ["PackageName", "FinalAmount"],
    };

    const keysToSearch = filterKeysMap[tabKey] || [];

    this.cardData = this.originalData.filter((item: any) => keysToSearch.some(key => item[key]?.toString().toLowerCase().includes(filterValue)));
  }
}
